export default {
  title: 'MAXHUB をアクティベート',
  instruction: 'ユーザーとディーラーの情報を正確に記入してください。この情報は、機械の保証とその他のサービスを直接に影響します。',
  dealername: 'ディーラーネーム',
  dealerplaceholder: 'ディーラーネーム',
  companyname: '社名',
  companyplaceholder: '社名',
  tele: '電話番号',
  teleplaceholder: '携帯電話',
  district: '地域を選択',
  distplaceholder: '地域インフォメーション',
  address: '詳しい連絡先',
  addrplaceholder: '詳しい連絡先',
  activebtn: 'アクティベーションコードを獲得',
  confirmbtn: '確認',
  cancelbtn: 'キャンセル',
  dialogmessage: '入力した連絡先電話番号の形式が間違っています。もう一度入力してください',
  dialogbtn: '確認',
  errortitle: 'オーペンできません',
  errorinfo1: '1.ネットワークを検査してください',
  errorinfo2: '2.アフターサービス電話番号：400-168-9545',
  nosn: 'このディバイスにはSNコードがありません、アクティベートできません',
  activepagetitle: 'アクティベーションコード',
  activepagehint: 'このディバイスをアクティベートするため、アクティベーションコードを入力してください、',
  finish: '完成する',
  search: '近くの位置を検索する'
};



// WEBPACK FOOTER //
// ./src/i18n/_ja.js